export default __webpack_public_path__ + "static/media/tronBTS.b6839d80.jpg";